import React, { useState, useEffect } from "react";
//import packageJson from "../package.json";
import moment from "moment";

const buildDateGreaterThan = (latestDate, currentDate) => {
    const momLatestDateTime = moment(latestDate);
    const momCurrentDateTime = moment(currentDate);

    if (momLatestDateTime.isAfter(momCurrentDateTime)) {
        return true;
    } else {
        return false;
    }
};

function withClearCache(Component) {
    function ClearCacheComponent(props) {
        const [isLatestBuildDate, setIsLatestBuildDate] = useState(false);

        useEffect(() => {
            fetch("./meta.json")
                .then(response => {
                    return response.json();
                })
                .then(meta => {
                    const latestVersionDate = meta.buildDate;

                    let currentVersionDate = localStorage.getItem("buildDate") && parseInt(localStorage.getItem("buildDate"));

                    if (currentVersionDate == null) {
                        let customDate = new Date();
                        customDate.setFullYear(customDate.getFullYear() - 1);

                        currentVersionDate = customDate;
                    }

                    //console.log('latestVersionDate', latestVersionDate);
                    //console.log('currentVersionDate', currentVersionDate);

                    const shouldForceRefresh = buildDateGreaterThan(
                        latestVersionDate,
                        currentVersionDate
                    );
                    if (shouldForceRefresh) {
                        setIsLatestBuildDate(false);
                        refreshCacheAndReload();
                        localStorage.setItem("buildDate", latestVersionDate);
                        console.log('Refresh cache');
                    } else {
                        setIsLatestBuildDate(true);
                        console.log('Cache ok');
                    }
                });
        }, []);

        const refreshCacheAndReload = () => {
            if (caches) {
                // Service worker cache should be cleared with caches.delete()
                caches.keys().then((names) => {
                    for (const name of names) {
                        caches.delete(name);
                    }
                });
            }
            // delete browser cache and hard reload
            window.location.reload(true);
        };

        return (
            <React.Fragment>
                {isLatestBuildDate ? <Component {...props} /> : null}
            </React.Fragment>
        );
    }

    return ClearCacheComponent;
}

export default withClearCache;